function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';

import Textarea from 'react-autosize-textarea';

var SelectInput = function (_Component) {
  _inherits(SelectInput, _Component);

  function SelectInput() {
    _classCallCheck(this, SelectInput);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.renderOptions = function (options) {
      return options && options.length > 0 ? options.map(function (option, index) {
        return React.createElement(
          'div',
          {
            className: 'ris-option' + (_this.state.selectedOption === option[_this.props.valueKey] ? ' selected' : '') + (_this.state.currentOption === index ? ' current' : ''),
            key: _this.props.uniqueKey + '-option-' + index,
            onClick: _this.handleClick.bind(_this, index),
            ref: function ref(_ref) {
              return _this['option-' + option[_this.props.valueKey]] = _ref;
            }
          },
          option[_this.props.labelKey]
        );
      }) : null;
    };

    _this.handleSelect = function (option, index) {
      var state = _this.manipState(_this.state, 'value', option[_this.props.labelKey]);
      state = _this.manipState(state, 'selectedOption', option[_this.props.valueKey]);
      state = _this.manipState(state, 'currentOption', -1);
      if (_this.props.collapseOnSelect) state = _this.setIsOpen(state, false);
      state = _this.manipState(state, 'searchMatchOptions', _this.matchingOptions(_this.props.options, state.value));
      _this.setState(state);

      if (_this.isFunction(_this.props.onSelect)) _this.props.onSelect(option);
    };

    _this.handleClick = function (index, event) {
      var option = _this.pickOption(index);
      _this.handleSelect(option, index);
    };

    _this.handleChange = function (event) {
      var state = _this.manipState(_this.state, 'value', event.target.value);
      state = _this.manipState(state, 'searchMatchOptions', _this.matchingOptions(_this.props.options, event.target.value));
      state = _this.setIsOpen(state, true);

      if (!state.value) {
        state = _this.manipState(state, 'currentOption', -1);
        state = _this.manipState(state, 'selectedOption', null);
      }

      if (_this.isFunction(_this.props.onChange)) _this.props.onChange(event);

      _this.setState(state);
    };

    _this.handleFocus = function (event) {
      var state = _this.setIsOpen(_this.state, true);
      state = _this.manipState(state, 'searchMatchOptions', _this.matchingOptions(_this.props.options, event.target.value));
      _this.setState(state);

      if (_this.isFunction(_this.props.onFocus)) _this.props.onFocus(event);
    };

    _this.handleClear = function () {
      var value = '';
      var state = _this.manipState(_this.state, 'value', value);
      state = _this.manipState(state, 'searchMatchOptions', _this.matchingOptions(_this.props.options, state.value));
      state = _this.manipState(state, 'currentOption', -1);
      state = _this.manipState(state, 'selectedOption', null);
      _this.setState(state);

      if (_this.isFunction(_this.props.onClear)) _this.props.onClear();
    };

    _this.handleBlur = function (event) {
      if (_this.props.collapseOnBlur) {
        var state = _this.setIsOpen(_this.state, false);
        _this.setState(state);
      }

      if (_this.isFunction(_this.props.onBlur)) _this.props.onBlur(event);
    };

    _this.handleKeyUp = function (event) {
      if (event.key === 'Enter' && _this.state.currentOption > -1) {
        _this.handleSelect(_this.pickOption());
      } else if (event.key === 'Enter' && _this.state.currentOption === -1) {
        _this.handleSelect(_this.pickOption());
      }

      if (event.key === 'Escape' && _this.props.collapseOnEscape) {
        _this.setState(_this.setIsOpen(_this.state, false));
      }

      if (_this.isFunction(_this.props.onKeyUp)) _this.props.onKeyUp(event);
    };

    _this.handleKeyDown = function (event) {
      if (event.key === 'Enter' && _this.props.disableEnter) event.preventDefault();

      if (event.key === 'Escape' && _this.props.collapseOnEscape) {
        var state = _this.setIsOpen(_this.state, false);
        _this.setState(state);
      }

      _this.handleOptionNavigation(event);

      if (_this.isFunction(_this.props.onKeyDown)) _this.props.onKeyDown(event);
    };

    _this.handleOptionNavigation = function (event) {
      var state = {};
      var currentOption = _this.state.currentOption;

      if (event.key === 'ArrowUp' || event.key === 'ArrowDown' && _this.disableEnter) event.preventDefault();

      if (event.key === 'ArrowUp' && currentOption === -1 && _this.props.openUp) currentOption = _this.state.searchMatchOptions.length;

      if (_this.props.openUp) {
        if (event.key === 'ArrowDown') {
          if (currentOption > -1) currentOption++;else currentOption = -1;
        } else if (event.key === 'ArrowUp') currentOption--;
      } else {
        if (event.key === 'ArrowDown') currentOption++;else if (event.key === 'ArrowUp') currentOption--;
      }

      if (currentOption < -1) currentOption = -1;else if (currentOption > _this.state.searchMatchOptions.length - 1 && !_this.props.openUp) currentOption = _this.state.searchMatchOptions.length - 1;else if (currentOption > _this.state.searchMatchOptions.length - 1 && _this.props.openUp) currentOption = -1;

      state = _this.manipState(_this.state, 'currentOption', currentOption);
      var optionRef = currentOption > -1 ? _this['option-' + _this.state.searchMatchOptions[currentOption][_this.props.valueKey]] : null;
      if (optionRef) optionRef.scrollIntoViewIfNeeded(false);

      _this.setState(state);
    };

    _this.matchingOptions = function (options, value) {
      var searchValue = value.replace(/\s/g, '');
      var searchOptions = [];

      if (options && options.length > 0 && value) searchOptions = options.filter(function (option, index) {
        var regexp = new RegExp(searchValue, 'gi');
        var value = option[_this.props.valueKey] || '';
        var label = option[_this.props.labelKey] || '';
        return regexp.test(label.replace(/\s/g, '')) || regexp.test(value.replace(/\s/g, ''));
      });else searchOptions = options.slice(0, options.length);

      if (_this.props.openUp) searchOptions.reverse();

      return searchOptions;
    };

    _this.pickOption = function (index) {
      var _ref2;

      index = index !== null && index !== undefined ? index : _this.state.currentOption;
      if (index > -1) return _this.state.searchMatchOptions[index];else return _ref2 = {}, _ref2[_this.props.labelKey] = _this.input.value.trim(), _ref2[_this.props.valueKey] = _this.input.value.trim(), _ref2;
    };

    _this.setIsOpen = function (state, show) {
      return Object.assign({}, state, {
        isOpen: show || false
      });
    };

    _this.manipState = function (state, key, value) {
      var _Object$assign;

      return Object.assign({}, state, (_Object$assign = {}, _Object$assign[key] = value, _Object$assign));
    };

    _this.isFunction = function (obj) {
      return typeof obj === 'function';
    };

    _this.handleOutsideClick = function (event) {
      if (!_this.ris.contains(event.target) && _this.props.collapseOnBlur) _this.setState(_this.setIsOpen(_this.state, false));
    };

    _this.state = {
      isOpen: false,
      value: null,
      currentOption: -1,
      selectedOption: null,
      searchMatchOptions: []
    };
    return _this;
  }

  SelectInput.prototype.componentDidMount = function componentDidMount() {
    document.addEventListener('click', this.handleOutsideClick);
  };

  SelectInput.prototype.componentDidUpdate = function componentDidUpdate() {
    if (this.props.openUp && this.state.currentOption === -1 && this.state.isOpen && !this.state.selectedOption) {
      this.options.scrollTop = this.options.scrollHeight;
    } else if (this.props.openUp && this.state.selectedOption && this.state.isOpen) {
      this['option-' + this.state.selectedOption].scrollIntoViewIfNeeded(true);
    }
  };

  SelectInput.prototype.componentWillUnmount = function componentWillUnmount() {
    document.removeEventListener('click', this.handleOutsideClick);
  };

  /*
    Various renderers
  */

  /*
    Handle different events
  */

  /*
    Searching function
  */

  /*
    Various helpers
  */

  SelectInput.prototype.render = function render() {
    var _this2 = this;

    return React.createElement(
      'div',
      {
        className: 'ris' + (this.props.openUp ? ' ris-open-up' : '') + (this.props.clearable ? ' ris-is-clearable' : '') + (this.props.className ? ' ' + this.props.className : ''),
        key: 'ris-' + this.props.uniqueKey,
        ref: function ref(_ref4) {
          return _this2.ris = _ref4;
        },
        style: this.props.style
      },
      React.createElement(Textarea, {
        className: 'ris-input',
        value: this.state.value !== null ? this.state.value : this.props.value,
        placeholder: this.props.placeholder,
        onChange: this.handleChange,
        onFocus: this.handleFocus,
        onBlur: this.props.onBlur,
        onKeyUp: this.handleKeyUp,
        onKeyDown: this.handleKeyDown,
        autoFocus: this.props.autoFocus,
        innerRef: function innerRef(ref) {
          return _this2.input = ref;
        }
      }),
      this.props.clearable ? React.createElement(
        'div',
        { className: 'ris-clearable', onClick: this.handleClear },
        'x'
      ) : null,
      this.state.isOpen ? this.state.searchMatchOptions.length > 0 ? React.createElement(
        'div',
        { className: 'ris-options', ref: function ref(_ref3) {
            return _this2.options = _ref3;
          } },
        this.renderOptions(this.state.searchMatchOptions)
      ) : this.props.noOptions ? React.createElement(
        'div',
        { className: 'ris-options ris-no-options' },
        this.props.noOptions
      ) : null : null
    );
  };

  return SelectInput;
}(Component);

export { SelectInput as default };


SelectInput.defaultProps = {
  uniqueKey: 'react-select-input', //String
  style: null, //Object
  ref: null, //Function
  value: '', //String
  valueKey: 'value', //String
  labelKey: 'label', //String
  placeholder: 'Enter text', //String
  className: '', //String
  openUp: false, //Boolean
  disableEnter: true, //Boolean
  collapseOnBlur: true, //Boolean
  collapseOnEscape: true, //Boolean
  collapseOnSelect: true, //Boolean
  autoFocus: true, //Boolean
  clearable: true, //Boolean
  options: [], //Array
  onChange: undefined, //Function
  onSelect: undefined, //Function
  onFocus: undefined, //Function
  onBlur: undefined, //Function
  onKeyUp: undefined, //Function
  onKeyDown: undefined, //Function
  onClear: undefined, //Function
  noOptions: undefined //JSX
};